import React from 'react';
import { Icon } from './Icon.js';
export const IconBallotRectFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "2", width: "6", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "2", y: "10", width: "6", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("path", { d: "M10.25,6h5c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75h-5c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M15.25,12h-5c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h5c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconBallotRectFill18.js.map